module.exports = __webpack_public_path__ + "static/media/B6.c95b4646.mp3";